import store from "@/store";
import UserSyncWebSocketService from "./userSyncWebsocketService";
import UserSyncSSEService from "./userSyncSSEService";
import { buildClientId, buildMercureSubscribePayload, buildSseTopics } from "./userSyncProfiles";
import mercureRepository from "./repository/mercureRepository";

class UserSyncService {
	static ACTION_ENABLE_MENU_BUTTON = 0;
	static ACTION_EVENT_WELCOME_GUEST = 23;

	constructor() {
		this.syncServices = [];
		this.eventHandler = null;
	}

	// Connects to both WebSocket and SSE simultaneously so events are received
	// regardless of which transport the scanned venue is configured to use.
	async connect({ userId }) {
		this.disconnect();

		const clientId = buildClientId(userId);
		this.eventHandler = this.handleIncomingEvent.bind(this);

		const wsService = new UserSyncWebSocketService(clientId);
		wsService.addMessageListener(this.eventHandler);
		this.syncServices.push(wsService);
		wsService.connect();

		const sseTopics = buildSseTopics(clientId);
		if (sseTopics.length > 0) {
			// Refresh the mercureAuthorization cookie before opening the EventSource so the
			// correct user-scoped topics are in the JWT regardless of how the session was
			// established (UID/QR path does not go through check-access?app=wepass).
			try {
				await mercureRepository.subscribe(buildMercureSubscribePayload());
			} catch (e) {
				console.warn("[UserSyncService] Mercure subscribe failed, SSE will use existing cookie", e);
			}
			const sseService = new UserSyncSSEService({ topics: sseTopics });
			sseService.addMessageListener(this.eventHandler);
			this.syncServices.push(sseService);
			sseService.connect();
		}
	}

	disconnect() {
		if (this.eventHandler) {
			this.syncServices.forEach((s) => {
				s.removeMessageListener(this.eventHandler);
				s.disconnect();
			});
		}
		this.syncServices = [];
		this.eventHandler = null;
	}

	handleIncomingEvent(type, data) {
		if (type !== "message" || data?.action == null) {
			return;
		}

		this.handleAction(data.action, data);
	}

	async handleAction(action, data) {
		switch (action) {
			case UserSyncService.ACTION_ENABLE_MENU_BUTTON:
				await store.dispatch("user/loadUserReservations");
				break;

			case UserSyncService.ACTION_EVENT_WELCOME_GUEST:
				store.commit("wePass/setEventWelcome", data.data);
				break;

			default:
				break;
		}
	}
}

export default new UserSyncService();
